// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
'use client'
import { UnexpectedError } from '@/components/UnexpectedError'
import { PageProvider } from 'providers/PageProvider/PageProvider'
import { getObjectOfPublicEnvs } from 'lib/getObjectOfPublicEnvs'
import { Suspense } from 'react'

export default function Custom500Page() {
  const publicProcessDotEnv = getObjectOfPublicEnvs()

  return (
    <Suspense fallback={null}>
      <PageProvider pageProps={{ publicProcessDotEnv: publicProcessDotEnv }}>
        <UnexpectedError />
      </PageProvider>
    </Suspense>
  )
}
